import { Resource } from 'kolibri.lib.apiResource';

/**
 * @example <caption>Get current session</caption>
 * SessionResource.getModel('current')
 */
export default new Resource({
  name: 'session',
});
